import type { LandingLocale } from '../../shared/content/landingContent.js';
import type { StaticPageAudience, StaticPageContent, StaticPageKey } from '../../shared/content/staticPageContent.js';
import type { LandingEditorProject } from '../../shared/editor/landingEditorTypes.js';

/**
 * Central access point for editor-managed content.
 *
 * Runtime pages and the editor must read through the same repository so the database snapshot is
 * always authoritative. TypeScript content is only used while creating or migrating a project.
 */
export class LandingProjectContentRepository {
  landing(project: LandingEditorProject, locale: LandingLocale) {
    return project.content[locale];
  }

  staticPage(
    project: LandingEditorProject,
    locale: LandingLocale,
    audience: StaticPageAudience,
    pageKey: StaticPageKey,
  ): StaticPageContent {
    return project.staticPages[locale][audience][pageKey];
  }

  staticPageRecord(
    project: LandingEditorProject,
    locale: LandingLocale,
    audience: StaticPageAudience,
    pageKey: StaticPageKey,
  ): Record<string, unknown> {
    return this.staticPage(project, locale, audience, pageKey) as unknown as Record<string, unknown>;
  }
}

export const landingProjectContentRepository = new LandingProjectContentRepository();
